import { useState, useEffect,useContext } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import tableStyle from '../Style/TableModel.module.css';
import formStyle from '../Style/modalForm.module.css';
import button from '../Style/ButtonStyle.module.css';
import { USERS_API_BASE_URL, SUPER_ADMIN_ID } from './../../constants';
import AuthContext from "../../store/auth-context";
import Checkbox from "./Checkbox";
import { IoIosEye, IoMdEyeOff } from 'react-icons/io';
import { BsCheck } from 'react-icons/bs';
import Loader from '../UI/Loader/Loader';


const AddUser = (props) => {
    const authCtx = useContext(AuthContext);
    const [userID, setUserID] = useState(0);
    const [userUUID, setUserUUID] = useState('');
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [designation, setDesignation] = useState("");
    const [userType, setUserType] = useState("");
    const [adminType, setAdminType] = useState(false);
    const [userPermission, setUserPermission] = useState([]);
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [usermessage, setUserMessage] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedOrgUuid, setSelectedOrgUuid] = useState('');
    const [organisationList, setOrganisationList] = useState([]);
    const [isLoadingOrgs, setIsLoadingOrgs] = useState(false);

    const [hasMinimumLength, setHasMinimumLength] = useState(false);
    const [hasUppercase, setHasUppercase] = useState(false);
    const [hasLowercase, setHasLowercase] = useState(false);
    const [hasNumeric, setHasNumeric] = useState(false);
    const [hasSpecialChar, setHasSpecialChar] = useState(false);
    
    // Field-specific error states
    const [userTypeError, setUserTypeError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [orgError, setOrgError] = useState('');
    const [generalError, setGeneralError] = useState('');
    
    //const [state, setState] = useState("");
    //const [location, setLocation] = useState("");
    //const [country, setCountry] = useState("");
    //console.log('udetail',props.userDetail);
    let permission = props.userDetailPermission;
    console.log('udetailPermission',props.userDetailPermission);
    
    const isSuperAdmin = authCtx.userData.user_id === SUPER_ADMIN_ID;
    
    // Extract org UUID from URL or props
    useEffect(() => {
        if (props.orgUuid) {
            // Coming from OrganisationDetail - use the provided orgUuid
            setSelectedOrgUuid(props.orgUuid);
        } else {
            const urlParams = window.location.hash.split('?')[1];
            if (urlParams) {
                // URL format: #users?8c337743-0078-4d19-b5ce-3a905c3e6f1a
                setSelectedOrgUuid(urlParams);
            } else if (!isSuperAdmin) {
                // Regular admin - use their organization
                setSelectedOrgUuid(authCtx.userData.orgId || authCtx.userData.org || '');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.orgUuid]);
    
    // Detect if opened from Internal Users tab and set defaults
    useEffect(() => {
        // Check if URL contains #internalUser or if opened from Internal Users context
        const hashPart = window.location.hash.split('?')[0];
        const isInternalUserContext = hashPart.includes('internalUser');
        
        // Only set defaults for new users (not editing existing ones)
        if (isInternalUserContext && !props.userDetail?.uuid) {
            setUserType('INTERNALADMIN');
            setAdminType(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.modalStatus, props.userDetail]);
    
    // Fetch organizations for super admin
    useEffect(() => {
        if (isSuperAdmin) {
            setIsLoadingOrgs(true);
            fetch(`${USERS_API_BASE_URL}/organisation`, {
                "method": "GET",
                "headers": {
                    "Content-Type": "application/json",
                    'Authorization': authCtx.token
                }
            })
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setOrganisationList(data);
                }
                setIsLoadingOrgs(false);
            })
            .catch(error => {
                console.error('Error fetching organisations:', error);
                setIsLoadingOrgs(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuperAdmin]);
    
    const SetInternalAdmin = () => {
        setAdminType(!adminType);   
    }
    useEffect(() => {
        // Check password conditions here
        const hasMinLength = password.length >= 7;
        const hasUpper = /[A-Z]/.test(password);
        const hasLower = /[a-z]/.test(password);
        const hasNum = /[0-9]/.test(password);
        const hasSpecial = /[!@#$%.:]/.test(password);
        setHasMinimumLength(hasMinLength);
        setHasUppercase(hasUpper);
        setHasLowercase(hasLower);
        setHasNumeric(hasNum);
        setHasSpecialChar(hasSpecial);
    },[password]);
    const generatePassword = () => {
        const length = 8;
        const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
        const numericChars = '0123456789';
        const specialChars = '!@#$%.:';
      
        let password = '';
        
        // Generate at least one character of each required type
        password += uppercaseChars[Math.floor(Math.random() * uppercaseChars.length)];
        password += lowercaseChars[Math.floor(Math.random() * lowercaseChars.length)];
        password += numericChars[Math.floor(Math.random() * numericChars.length)];
        password += specialChars[Math.floor(Math.random() * specialChars.length)];
      
        // Generate remaining characters randomly
        for (let i = 0; i < length - 4; i++) {
          const charset = uppercaseChars + lowercaseChars + numericChars + specialChars;
          const randomIndex = Math.floor(Math.random() * charset.length);
          password += charset[randomIndex];
        }
      
        return password;
      };

    const handleGeneratePassword = () => {
        const generatedPassword = generatePassword();
        //checkPasswordConditions(generatedPassword);
        
        setPassword(generatedPassword);
    };
    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    const selectUserpermission = (per,checkedVal) =>{
        if(checkedVal==true && userPermission.includes(per)==false){
            setUserPermission([...userPermission,per]);
        }else if(checkedVal==false && userPermission.includes(per)==true){
            var index = userPermission.indexOf(per)
            if (index !== -1) {
                userPermission.splice(index, 1);
                setUserPermission(userPermission);
            }
        } 
    }
    //console.log('admintype===',adminType);
   // console.log('permission===',authCtx.userData);
    useEffect(() => {
        // Guard clause: only proceed if userDetail exists and has data
        if(!props.userDetail || !props.userDetail.uuid) {
            // Check if we're in Internal Users context
            const hashPart = window.location.hash.split('?')[0];
            const isInternalUserContext = hashPart.includes('internalUser');
            
            // Reset form for new user
            setFirstName('');
            setLastName('');
            setDesignation('');
            setPhone('');
            setEmail('');
            setUserID(0);
            setUserUUID('');
            // Keep Internal Users defaults if in that context
            if (!isInternalUserContext) {
                setUserType('');
                setAdminType(false);
            }
            setUserPermission([]);
            setIsLoading(false);
            setUserTypeError('');
            setEmailError('');
            setPasswordError('');
            setPhoneError('');
            setFirstNameError('');
            setLastNameError('');
            setOrgError('');
            setGeneralError('');
            return;
        }
        
        // Edit existing user
        setIsLoading(true);
        setFirstName(props.userDetail.firstName);
        setUserType(props.userDetail.usertype);
        if(props.userDetail.usertype=='INTERNALADMIN'){
            setAdminType(true);
        }
        setLastName(props.userDetail.lastName);
        setDesignation(props.userDetail.designation || '');
        setPhone(props.userDetail.phoneNumber);
        setEmail(props.userDetail.email);
        if(props.userDetail.id){
            setUserID(props.userDetail.id);
        }

        setUserUUID(props.userDetail.uuid);
        
        // Pre-select organization for ADMIN users
        if (props.userDetail.org) {
            setSelectedOrgUuid(props.userDetail.org);
        }
        //console.log('p=======',permission);
        //console.log('pllll=======',permission.length)
        if(permission.length > 0){
            //alert(1);
            permission.map((uper)=>{
                setUserPermission([...userPermission,uper.fk_module_id]);
            })
        }
        
        setIsLoading(false);
    }, [permission, props.userDetail])
    const UserAdded = (e) => {
        e.preventDefault();
        
        // Clear previous errors
        setUserTypeError('');
        setEmailError('');
        setPasswordError('');
        setPhoneError('');
        setFirstNameError('');
        setLastNameError('');
        setOrgError('');
        setGeneralError('');
        
        // Client-side validation
        let hasErrors = false;
        
        if (!userType || userType === '') {
            setUserTypeError('User type is required');
            hasErrors = true;
        }
        
        if (!email || email.trim() === '') {
            setEmailError('Email is required');
            hasErrors = true;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError('Please enter a valid email address');
            hasErrors = true;
        }
        
        // Password validation only for new users
        if (userID === 0 && (!password || password.trim() === '')) {
            setPasswordError('Password is required');
            hasErrors = true;
        }
        
        if (hasErrors) {
            return;
        }
        
        setIsLoading(true);
        
        // Determine which org UUID to use
        let orgUuidToUse = selectedOrgUuid;
        
        // Validation: orguuid cannot be blank unless user type is INTERNALADMIN or INTERNALUSER
        if (!orgUuidToUse && userType !== 'INTERNALADMIN' && userType !== 'INTERNALUSER') {
            setIsLoading(false);
            props.setMessage('Please select an organization');
            return;
        }
        
        if(userID==0){
            fetch(`${USERS_API_BASE_URL}/create-user`, {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": authCtx.token
                },
                "body":
                    "{\"firstName\":\"" + firstName + "\",\"lastName\":\"" + lastName + "\",\"designation\":\"" + designation + "\",\"phoneNumber\":\"" + phone + "\",\"password\":\"" + password + "\",\"email\":\"" + email + "\",\"usertype\":\"" + userType + "\",\"orguuid\":\"" + orgUuidToUse + "\" ,\"userpermission\":\"" + userPermission + "\" ,\"userAddedBy\":\"" + authCtx.userData.user_id + "\"  }"

            }).then(res=>res.json()).then(data=>{

                setIsLoading(false);
                if(data.status==302 || data.status==400 || data.status==403){
                    // Handle server-side validation errors
                    if (data.field) {
                        switch(data.field) {
                            case 'userType':
                                setUserTypeError(data.error);
                                break;
                            case 'email':
                                setEmailError(data.error);
                                break;
                            case 'password':
                                setPasswordError(data.error);
                                break;
                            case 'phone':
                                setPhoneError(data.error);
                                break;
                            case 'firstName':
                                setFirstNameError(data.error);
                                break;
                            case 'lastName':
                                setLastNameError(data.error);
                                break;
                            case 'organization':
                                setOrgError(data.error);
                                break;
                            default:
                                setGeneralError(data.error);
                        }
                    } else {
                        // Check if error is related to email (user exists, email exists, etc.)
                        const errorLower = (data.error || '').toLowerCase();
                        if (errorLower.includes('email')) {
                            setEmailError(data.error);
                        } else if (data.error) {
                            setGeneralError(data.error);
                        }
                    }
                }else{
                    props.setMessage(data.msg)
                    
                    // Add newly created user to the list
                    if(props.userList){
                        props.setUserList([...props.userList,{
                            id: data.newUserID, 
                            uuid: data.newUserUUID,
                            firstName: firstName,
                            lastName: lastName,
                            email: email,
                            phoneNumber: phone,
                            usertype: data.newUserType,
                            designation: designation || '',
                            org: orgUuidToUse || '',
                            status: 'ACTIVE'
                        }]);
                    }

                    setFirstName('');
                    setLastName('');
                    setDesignation('');
                    setPhone('');
                    setEmail('');
                    setPassword('');
                    setUserID(0);
                    setUserUUID('');
                    setUserType('');
                    setSelectedOrgUuid('');
                    setFirstNameError('');
                    setLastNameError('');
                    setOrgError('');
                    setGeneralError('');
                    props.onAction(false);
                }

            }).catch(error => {
                setIsLoading(false);
                setGeneralError('An unexpected error occurred. Please try again.');
                console.error('Error creating user:', error);
            })
        }else{
            // Build the body dynamically - only include password if it's provided
            const updateBody: any = {
                firstName: firstName,
                lastName: lastName,
                designation: designation,
                phoneNumber: phone,
                email: email,
                usertype: userType,
                userpermission: userPermission.toString()
            };
            
            // Only include password if it's not empty (super admin changing password)
            if (password && password.trim() !== '') {
                updateBody.password = password;
            }
            
            fetch(`${USERS_API_BASE_URL}/put-user-profile/`+userUUID, {
                "method": "PUT",
                "headers": {
                    "Content-Type": "application/json",
                    'Authorization':authCtx.token
                },
                "body": JSON.stringify(updateBody)

            }).then(res=>res.json()).then(data=>{

                setIsLoading(false);
                if(data.status==302 || data.status==400 || data.status==300 || data.status==403){
                    // Handle server-side validation errors
                    if (data.field) {
                        switch(data.field) {
                            case 'userType':
                                setUserTypeError(data.error);
                                break;
                            case 'email':
                                setEmailError(data.error);
                                break;
                            case 'phone':
                                setPhoneError(data.error);
                                break;
                            case 'firstName':
                                setFirstNameError(data.error);
                                break;
                            case 'lastName':
                                setLastNameError(data.error);
                                break;
                            case 'organization':
                                setOrgError(data.error);
                                break;
                            default:
                                setGeneralError(data.error);
                        }
                    } else {
                        // Check if error is related to email (user exists, email exists, etc.)
                        const errorLower = (data.error || '').toLowerCase();
                        if (errorLower.includes('email')) {
                            setEmailError(data.error);
                        } else if (data.error) if (data.error) {
                            setGeneralError(data.error);
                        }
                    }
                }else{
                    props.setMessage(data.msg)
                    if(props.userList){
                        const index = props.userList.findIndex(data => data.id === userID),
                        userData = [...props.userList] // important to create a copy, otherwise you'll modify state outside of setState call
                        userData[index] = {id:userID, uuid:userUUID, firstName:firstName,lastName:lastName,email:email,phoneNumber:phone,usertype:userType};
                        console.log(userData)
                        props.setUserList(userData);
                    }
                    setFirstName('');
                    setLastName('');
                    setDesignation('');
                    setPhone('');
                    setEmail('');
                    setPassword('');
                    setUserID(0);
                    setUserUUID('');
                    setUserType('');
                    setSelectedOrgUuid('');
                    setAdminType(false);
                    setUserPermission([]);
                    setFirstNameError('');
                    setLastNameError('');
                    setOrgError('');
                    setGeneralError('');
                    props.onAction(false);
                }
                // if(props.userList){
                //     props.setUserList([...props.userList,{id:data.newUserID, firstName:firstName,lastName:lastName,email:email,phoneNumber:phone}]);
                // }






            }).catch(error => {
                setIsLoading(false);
                setGeneralError('An unexpected error occurred. Please try again.');
                console.error('Error updating user:', error);
            })
        }


    }
    console.log('userSelectedPermission====',userPermission);
    return (
        <>
            <Modal
                size="lg"
                show={props.modalStatus}
                onHide={props.onAction}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <div className={formStyle.headArea}>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        <h4 className={tableStyle.modalTitle}> Create New / Edit User</h4>
                    </Modal.Title>
                </div>
                <div className='Modify_PageTitle__VS3pb FontFamily_fontMedium__1Bl7w' style={{"fontSize":14}}>{usermessage}</div>
                {generalError && <div style={{margin: '8px 16px', padding: '8px 12px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', color: '#856404', fontSize: '13px'}}>{generalError}</div>}
                {isLoading ? (
                    <div className={formStyle.bodyArea} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px'}}>
                        <Spinner animation="border" variant="primary" />
                        <span style={{marginLeft: '10px'}}>Loading user data...</span>
                    </div>
                ) : (
                <form onSubmit={UserAdded} >
                <div className={formStyle.bodyArea}>

                        <div className="row">
                            <div className="col-ms-12">
                                {authCtx.userData.user_id===SUPER_ADMIN_ID && !props.orgUuid && !window.location.hash.includes('internalUser') && <div className={formStyle.group}>
                                    <input type="checkbox" checked={adminType} placeholder="Internal Admin" value={adminType ? "true" : "false"} onChange={SetInternalAdmin}  /> Internal Admin
                                </div>}
                                
                                {!window.location.hash.includes('internalUser') ? (
                                    <div className={formStyle.group}>
                                        <select autoFocus value={userType} title='Select Usertype'  className={formStyle.formControl} onChange={e => { setUserType(e.target.value); setUserTypeError(''); }} required>
                                            <option value={''} className={formStyle.formControl}>--Select Usertype--</option>
                                            
                                            <option selected value="ADMIN">Admin</option>
                                        
                                        </select>
                                        {userTypeError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{userTypeError}</div>}
                                    </div>
                                ) : (
                                    <input type="hidden" value={userType} />
                                )}
                                
                                {/* Organization selection for Super Admin - hide when orgUuid prop is provided */}
                                {isSuperAdmin && !props.orgUuid && userType !== 'INTERNALADMIN' && userType !== 'INTERNALUSER' && (
                                    <div className={formStyle.group}>
                                        <select 
                                            value={selectedOrgUuid} 
                                            title='Select Organization' 
                                            className={formStyle.formControl} 
                                            onChange={e => { setSelectedOrgUuid(e.target.value); setOrgError(''); }}
                                            required={userType !== 'INTERNALADMIN' && userType !== 'INTERNALUSER'}
                                        >
                                            <option value=''>--Select Organization--</option>
                                            {organisationList.map(org => (
                                                <option key={org.uuid} value={org.uuid}>
                                                    {org.name}
                                                </option>
                                            ))}
                                        </select>
                                        {isLoadingOrgs && <small>Loading organizations...</small>}
                                        {orgError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{orgError}</div>}
                                    </div>
                                )}
                                
                                {/* Hidden field for regular admin - shows their org */}
                                {!isSuperAdmin && userType !== 'INTERNALADMIN' && userType !== 'INTERNALUSER' && (
                                    <input type="hidden" value={selectedOrgUuid} />
                                )}
                                
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="First Name" title='First Name' className={formStyle.formControl} value={firstName} onChange={e => { setFirstName(e.target.value); setFirstNameError(''); }} />
                                    {firstNameError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{firstNameError}</div>}
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Last Name" title='Last Name' className={formStyle.formControl} value={lastName} onChange={e => { setLastName(e.target.value); setLastNameError(''); }} />
                                    {lastNameError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{lastNameError}</div>}
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Designation" title='Designation' className={formStyle.formControl} value={designation} onChange={e => setDesignation(e.target.value)} />
                                </div>
                                <div className={formStyle.group}>
                                    <input type="email" placeholder="Email" title='Email' className={formStyle.formControl} value={email} onChange={e => { setEmail(e.target.value); setEmailError(''); }} required />
                                    {emailError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{emailError}</div>}
                                </div>
                                <div className={formStyle.group}>
                                    <input type="text" placeholder="Phone" title='Phone' className={formStyle.formControl} value={phone} onChange={e => { setPhone(e.target.value); setPhoneError(''); }} />
                                    {phoneError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{phoneError}</div>}
                                </div>
                                { (userID == 0 || isSuperAdmin) ? <div className={formStyle.group + ' ' + formStyle.createPassword}>
                                    <div className={formStyle.passwordBox}>
                                        <input 
                                            type={showPassword ? 'text' : 'password'} 
                                            placeholder={userID == 0 ? "Password" : "New Password (leave blank to keep current)"} 
                                            title='Password' 
                                            className={formStyle.formControl} 
                                            value={password} 
                                            onChange={e => { setPassword(e.target.value); setPasswordError(''); }} 
                                            required={userID == 0} 
                                        />
                                        <button type="button" className={formStyle.passwordShow} onClick={handleTogglePassword}>{showPassword ? <IoMdEyeOff /> : <IoIosEye /> }</button>
                                    </div>
                                    {passwordError && <div style={{color: 'red', fontSize: '12px', marginTop: '5px', marginBottom: '10px'}}>{passwordError}</div>}
                                    <button type="button" className={button.btn + ' ' + button.brownButton + ' ' + formStyle.Generatebtn} onClick={handleGeneratePassword}>Generate Password</button>
                                    <label>
                                        <span className={formStyle.checkArea}>{hasMinimumLength && <BsCheck className={formStyle.passCheck} /> }</span>
                                        {/* <input type="checkbox" checked={hasMinimumLength} disabled /> */}
                                        <span className={formStyle.ex_spm}>Eight characters</span> <span className={formStyle.checkmark}></span>
                                    </label>
                                    <label>
                                        <span className={formStyle.checkArea}>{hasUppercase && <BsCheck className={formStyle.passCheck} /> }</span>
                                        {/* <input type="checkbox" checked={hasUppercase} disabled /> */}
                                     <span className={formStyle.ex_spm}>One uppercase letter</span> <span className={formStyle.checkmark}></span>
                                    </label>
                                    <label>
                                        <span className={formStyle.checkArea}>{hasLowercase && <BsCheck className={formStyle.passCheck} /> }</span>
                                        {/* <input type="checkbox" checked={hasLowercase} disabled /> */}
                                        <span className={formStyle.ex_spm}>One lowercase letter</span> <span className={formStyle.checkmark}></span>
                                    </label>
                                    <label>
                                        <span className={formStyle.checkArea}>{hasNumeric && <BsCheck className={formStyle.passCheck} /> }</span>
                                        {/* <input type="checkbox" checked={hasNumeric} disabled /> */}
                                        <span className={formStyle.ex_spm}>One numeric digit</span> <span className={formStyle.checkmark}></span>
                                    </label>
                                    <label>
                                        <span className={formStyle.checkArea}>{hasSpecialChar && <BsCheck className={formStyle.passCheck} /> }</span>
                                        {/* <input type="checkbox" checked={hasSpecialChar} disabled /> */}
                                        <span className={formStyle.ex_spm}>One special character(!@#$%.:| allowed)</span> <span className={formStyle.checkmark}></span>
                                    </label>
                                </div> : null }
                                {adminType=== true && <div className={formStyle.group}>
                                    <div>Permissions: </div>
                                    {props.moduleList.map((module) => {
                                        //alert(JSON.stringify(props.userDetailPermission).includes(module.id))
                                        return (
                                            <div>
                                            <Checkbox 
                                            selectUserpermission={selectUserpermission}
                                            module={module}
                                            userSelectedPermission={props.userDetailPermission}
                                            setIsChecked={setIsChecked}
                                            isChecked={isChecked}
                                            />
                                            </div>
                                        )
                                        // return (
                                        //     <div key={module.id}>
                                        //         {JSON.stringify(props.userDetailPermission).includes(module.id)?<input type="checkbox" checked={module.id} placeholder={module.name} onChange={e => selectUserpermission(module.id)}  />:<input type="checkbox" checked={''} placeholder={module.name} onChange={e => selectUserpermission(module.id)}  />  }
                                        //         {module.name}
                                        //     </div>
                                        // )
                                    })}
                                    


                                </div>}

                                
                                


                            </div>
                        </div>

                </div>
                <div className={formStyle.FooterArea}>
                    <button type="button" onClick={props.onAction} className={button.btn + ' ' + button.brownButton}>Cancel</button>
                    <button type="submit" className={button.btn + ' ' + button.blueButton + ' ' + button.buttonSpaceLeft}>Save</button>
                </div>
                </form>
                )}
            </Modal>
            {isLoading && <Loader />}
        </>
    )
}
export default AddUser;
